import {
  ElementClientRect,
  ElementGraphicRect,
  ElementPrintAreaRect,
} from '../../models/common/elementClientRect'
import {Img} from '../../models/editor/img'
import {
  getElementClientPositionById,
  getElementClientRect,
  getRectEndValues,
} from './elementClientRect'

export const getPrintAreaClientRect = (
  printArea?: Img,
): ElementPrintAreaRect | null => {
  if (!printArea) {
    return null
  }

  const elementClientRect = getElementClientPositionById(printArea.id)
  return elementClientRect
    ? {...elementClientRect, type: 'printArea'}
    : elementClientRect
}

export const getPrintAreaItemsMergedClientRect = (
  images: Img[],
): ElementClientRect | null => {
  let rect: ElementClientRect | null = null

  images.forEach((image: Img, index: number) => {
    if (0 === index) {
      return
    }

    if ('caption' === image.type) {
      const parentElement = document.getElementById(image.id)

      if (!parentElement) {
        return
      }

      const textElements = parentElement.querySelectorAll('text')

      if (!textElements.length) {
        return
      }

      textElements.forEach((textElement: SVGTextElement) => {
        rect = getRectEndValues(rect, getElementClientRect(textElement))
      })

      return
    }

    rect = getRectEndValues(rect, getElementClientPositionById(image.id))
  })

  return rect
}

export const getPrintAreaItemsClientRects = (
  images: Img[],
): ElementGraphicRect[] => {
  const rects: ElementGraphicRect[] = []
  images.forEach((image: Img, index: number) => {
    if (0 === index) {
      return
    }
    if ('caption' === image.type) {
      const parentElement = document.getElementById(image.id)
      if (!parentElement) {
        return
      }
      const textElements = parentElement.querySelectorAll('text')

      let rect: ElementClientRect | null = null
      textElements.forEach((textElement: SVGTextElement) => {
        rect = getRectEndValues(rect, getElementClientRect(textElement))
      })
      if (rect) {
        rects.push({...(rect as ElementClientRect), type: 'caption'})
      }
    } else {
      const rect = getElementClientPositionById(image.id)
      if (rect) {
        rects.push({...rect, type: 'graphic'})
      }
    }
  })

  return rects
}

export const doPrintAreaContentOverflow = (
  printAreaItems: Img[],
  printArea?: Img,
): boolean => {
  const printAreClientRect = getPrintAreaClientRect(printArea)
  const printAreaItemsClientRect =
    getPrintAreaItemsMergedClientRect(printAreaItems)

  if (!printAreClientRect || !printAreaItemsClientRect) {
    return false
  }

  return (
    printAreClientRect.x1 > printAreaItemsClientRect.x1 ||
    printAreClientRect.x2 < printAreaItemsClientRect.x2 ||
    printAreClientRect.y1 > printAreaItemsClientRect.y1 ||
    printAreClientRect.y2 < printAreaItemsClientRect.y2
  )
}
